// @flow
import client from '../../client'

// API Endpoints
export const USER_REACTIVATE = '/auth/users/reactivate-account/'

/**
 * Reactivates a previously suspended account.
 * @param  {Object} data User account information
 * @param  {string} data.email User account email
 * @param  {string} data.password User password
 * @return {Promise|Error} A resolved Promise with the boolean response or Rejected with an Error
 */
export const activate = (data: {
  email: string,
  password: string,
}): Promise<any> => {
  const options = {
    body: { ...data },
  }

  // API V2 returns the whole user object after reactivation
  return client.post(USER_REACTIVATE, options).then(() => true)
}

export default activate
